export const LICENSE_LOAD_REQUEST = 'LICENSE_LOAD_REQUEST';
export const LICENSE_LOAD_SUCCESS = 'LICENSE_LOAD_SUCCESS';
export const LICENSE_LOAD_FAILURE = 'LICENSE_LOAD_FAILURE';
